import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PageSearch = ({ pagenumber, getpagenumber }) => {
    const orders = useSelector(state => state.orders);
    const [pageNo, setPageNo] = useState("");
    
    const onInputChange = (e) => {
        let pagenumber = ''; 
        pagenumber = e.target.value;
        setPageNo(pagenumber);
    };
    
    const onPageChange = () => {
        if (pageNo >= 1 && pageNo <=  orders.ordersData.meta.last_page) {
            getpagenumber(pageNo);
        }
    };
    
    return (
        <>
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'flex-end', 
                    gap: 1.5
                }}
            >
                {/* Clean Descriptive Inline Metric Label */}
                <Typography 
                    sx={{ 
                        fontSize: '13px', 
                        fontWeight: 600, 
                        color: '#64748B',
                        whiteSpace: 'nowrap'
                    }}
                >
                    Go to Page
                </Typography>
                
                {/* Modernized Numeric Value Layout Node */}
                <TextField
                    autoComplete='off'
                    defaultValue={pagenumber ? pagenumber : pageNo}
                    id="outlined-basic"
                    type="number"
                    size='small'
                    inputProps={{ min: 1 }}
                    onInput={onInputChange}
                    variant="outlined" 
                    sx={{ 
                        width: '75px',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                            transition: 'all 0.2s',
                            border: '1px solid #E2E8F0',
                            '& fieldset': { border: 'none' },
                            '&:hover': { borderColor: '#CBD5E1' },
                            '&.Mui-focused': {
                                borderColor: '#1976d2',
                                boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                            }
                        },
                        '& input': {
                            padding: '6.5px 10px',
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#1E293B',
                            textAlign: 'center',
                            MozAppearance: 'textfield',
                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0
                            }
                        }
                    }}
                />
                
                {/* Navigation Jump Execution Pipeline Link Button */}
                <Button 
                    variant="contained" 
                    onClick={onPageChange}
                    sx={{ 
                        height: '32px', 
                        px: 2,
                        textTransform: 'none',
                        borderRadius: '8px',
                        fontWeight: 700,
                        fontSize: '13px',
                        boxShadow: 'none',
                        backgroundColor: '#1976d2', // --- CORPORATE IDENTITY ACCENT SYNC ---
                        color: '#FFFFFF',
                        '&:hover': {
                            backgroundColor: '#115293',
                            boxShadow: 'none'
                        }
                    }}
                >
                    Jump
                </Button>
            </Box>
        </>
    )
};

export default PageSearch;